export default {
  meetings: [
   
  ],
  totalMeetings: 0,
  meetingsActionsCount: 0

};
